import axios from "axios";

export function spollers() {
    const spollersArray = document.querySelectorAll("[data-spollers]");
    if (spollersArray.length > 0) {
        const spollersRegular = Array.from(spollersArray).filter(function (
            item,
            index,
            self
        ) {
            return !item.dataset.spollers.split(",")[0];
        });
        if (spollersRegular.length > 0) {
            initSpollers(spollersRegular);
        }
        const spollersMedia = Array.from(spollersArray).filter(function (
            item,
            index,
            self
        ) {
            return item.dataset.spollers.split(",")[0];
        });
        if (spollersMedia.length > 0) {
            const breakpointsArray = [];
            spollersMedia.forEach((item) => {
                const params = item.dataset.spollers;
                const breakpoint = {};
                const paramsArray = params.split(",");
                breakpoint.value = paramsArray[0];
                breakpoint.type = paramsArray[1]
                    ? paramsArray[1].trim()
                    : "max";
                breakpoint.item = item;
                breakpointsArray.push(breakpoint);
            });
            let mediaQueries = breakpointsArray.map(function (item) {
                return (
                    "(" +
                    item.type +
                    "-width: " +
                    item.value +
                    "px)," +
                    item.value +
                    "," +
                    item.type
                );
            });
            mediaQueries = mediaQueries.filter(function (item, index, self) {
                return self.indexOf(item) === index;
            });
            mediaQueries.forEach((breakpoint) => {
                const paramsArray = breakpoint.split(",");
                const mediaBreakpoint = paramsArray[1];
                const mediaType = paramsArray[2];
                const matchMedia = window.matchMedia(paramsArray[0]);

                const spollersArray = breakpointsArray.filter(function (item) {
                    if (
                        item.value === mediaBreakpoint &&
                        item.type === mediaType
                    ) {
                        return true;
                    }
                });
                // Событие
                matchMedia.addEventListener("change", function () {
                    initSpollers(spollersArray, matchMedia);
                });
                initSpollers(spollersArray, matchMedia);
            });
        }
        // Initializing
        function initSpollers(spollersArray, matchMedia = false) {
            spollersArray.forEach((spollersBlock) => {
                spollersBlock = matchMedia ? spollersBlock.item : spollersBlock;
                if (matchMedia.matches || !matchMedia) {
                    spollersBlock.classList.add("_spoller-init");
                    initSpollerBody(spollersBlock);
                    spollersBlock.addEventListener("click", setSpollerAction);
                } else {
                    spollersBlock.classList.remove("_spoller-init");
                    initSpollerBody(spollersBlock, false);
                    spollersBlock.removeEventListener(
                        "click",
                        setSpollerAction
                    );
                }
            });
        }
        // Working with content
        function initSpollerBody(spollersBlock, hideSpollerBody = true) {
            const spollerTitles =
                spollersBlock.querySelectorAll("[data-spoller]");
            if (spollerTitles.length > 0) {
                spollerTitles.forEach((spollerTitle) => {
                    if (hideSpollerBody) {
                        spollerTitle.removeAttribute("tabindex");
                        if (
                            !spollerTitle.classList.contains("_spoller-active")
                        ) {
                            spollerTitle.nextElementSibling.hidden = true;
                        }
                    } else {
                        spollerTitle.setAttribute("tabindex", "-1");
                        spollerTitle.nextElementSibling.hidden = false;
                    }
                });
            }
        }
        function setSpollerAction(e) {
            const el = e.target;
            if (
                el.hasAttribute("data-spoller") ||
                el.closest("[data-spoller]")
            ) {
                const spollerTitle = el.hasAttribute("data-spoller")
                    ? el
                    : el.closest("[data-spoller]");
                const spollersBlock = spollerTitle.closest("[data-spollers]");
                const oneSpoller = spollersBlock.hasAttribute(
                    "data-one-spoller"
                )
                    ? true
                    : false;
                if (!spollersBlock.querySelectorAll("._slide").length) {
                    if (
                        oneSpoller &&
                        !spollerTitle.classList.contains("_spoller-active")
                    ) {
                        hideSpollersBody(spollersBlock);
                    }
                    spollerTitle.classList.toggle("_spoller-active");
                    _slideToggle(spollerTitle.nextElementSibling, 500);
                }
                e.preventDefault();
            }
        }
        function hideSpollersBody(spollersBlock) {
            const spollerActiveTitle = spollersBlock.querySelector(
                "[data-spoller]._spoller-active"
            );
            if (spollerActiveTitle) {
                spollerActiveTitle.classList.remove("_spoller-active");
                _slideUp(spollerActiveTitle.nextElementSibling, 500);
            }
        }
    }
}

export let _slideUp = (target, duration = 500, showmore = 0) => {
    if (!target.classList.contains("_slide")) {
        target.classList.add("_slide");
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + "ms";
        target.style.height = `${target.offsetHeight}px`;
        target.offsetHeight;
        target.style.overflow = "hidden";
        target.style.height = showmore ? `${showmore}px` : `0px`;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(() => {
            target.hidden = !showmore ? true : false;
            !showmore ? target.style.removeProperty("height") : null;
            target.style.removeProperty("padding-top");
            target.style.removeProperty("padding-bottom");
            target.style.removeProperty("margin-top");
            target.style.removeProperty("margin-bottom");
            !showmore ? target.style.removeProperty("overflow") : null;
            target.style.removeProperty("transition-duration");
            target.style.removeProperty("transition-property");
            target.classList.remove("_slide");
        }, duration);
    }
};
export let _slideDown = (target, duration = 500, showmore = 0) => {
    if (!target.classList.contains("_slide")) {
        target.classList.add("_slide");
        target.hidden = target.hidden ? false : null;
        showmore ? target.style.removeProperty("height") : null;
        let height = target.offsetHeight;
        target.style.overflow = "hidden";
        target.style.height = showmore ? `${showmore}px` : `0px`;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + "ms";
        target.style.height = height + "px";
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        window.setTimeout(() => {
            target.style.removeProperty("height");
            target.style.removeProperty("overflow");
            target.style.removeProperty("transition-duration");
            target.style.removeProperty("transition-property");
            target.classList.remove("_slide");
        }, duration);
    }
};
export let _slideToggle = (target, duration = 500) => {
    if (target.hidden) {
        return _slideDown(target, duration);
    } else {
        return _slideUp(target, duration);
    }
};

// Format phone number
export function phoneMask() {
    var maskedInputs = document.querySelectorAll("[data-mask]");

    for (var index = 0; index < maskedInputs.length; index++) {
        maskedInputs[index].addEventListener("input", maskInput);
    }

    function maskInput() {
        var input = this;
        var mask = input.dataset.mask;
        console.log(mask);
        var value = input.value;
        var literalPattern = /[0\*]/;
        var numberPattern = /[0-9]/;
        var newValue = "";
        try {
            var maskLength = mask.length;
            var valueIndex = 0;
            var maskIndex = 0;

            for (; maskIndex < maskLength; ) {
                if (maskIndex >= value.length) break;

                if (
                    mask[maskIndex] === "0" &&
                    value[valueIndex].match(numberPattern) === null
                )
                    break;

                // Found a literal
                while (mask[maskIndex].match(literalPattern) === null) {
                    if (value[valueIndex] === mask[maskIndex]) break;
                    newValue += mask[maskIndex++];
                }
                newValue += value[valueIndex++];
                maskIndex++;
            }

            input.value = newValue;
        } catch (e) {
            console.log(e);
        }
    }
}

export function selectOptions() {
    // Variables
    const dropdownItems = document.querySelectorAll(".select-dropdown");
    const input = document.querySelector(".select-dropdown__input");
    const listOfOptions = document.querySelectorAll(".select-dropdown__option");
    const body = document.body;

    function toggleDropdown(event) {
        event.stopPropagation();
        const dropdown = this;
        const isOption = event.target.classList.contains(
            "select-dropdown__option"
        );

        // Если клик был на выпадающем меню и оно уже открыто, закрываем его
        if (!isOption && dropdown.classList.contains("opened")) {
            dropdown.classList.remove("opened");
            return;
        }

        // Закрываем все открытые меню, кроме текущего
        dropdownItems.forEach((item) => {
            if (item !== dropdown) {
                item.classList.remove("opened");
            }
        });

        // Тогглим текущее меню
        dropdown.classList.toggle("opened");

        if (isOption) {
            const optionItem = event.target;
            const input = dropdown.querySelector(".select-dropdown__input");

            // Ваш код для обработки клика на элементе optionItem
            input.value = optionItem.textContent;
            input.setAttribute("data-selected", optionItem.textContent);
            input.setAttribute(
                "data-id",
                optionItem.getAttribute("data-option")
            );
        }
    }

    function closeAllDropdowns() {
        const openedDropdowns = document.querySelectorAll(
            ".select-dropdown.opened"
        );
        openedDropdowns.forEach((dropdown) => {
            dropdown.classList.remove("opened");
        });
    }

    body.addEventListener("click", closeAllDropdowns);

    dropdownItems.forEach((dropdownItem) => {
        dropdownItem.addEventListener("click", toggleDropdown);
    });

    function selectOption(event) {
        input.value = event.currentTarget.textContent;
        const optionId = this.getAttribute("data-option");
        input.setAttribute("data-selected", event.currentTarget.textContent);
        input.setAttribute("data-id", optionId);
    }
}

export function recordPersonalTraining() {
    const formContainer = document.getElementById(
        "personal-training-form-record-container"
    );
    const form = document.getElementById("personal-training-form-record");
    const successMessage = document.getElementById(
        "personal-training-from-record-success-message"
    );

    const ageGroup = document.getElementById('age_group');

    const selectTrainer = document.getElementById(
        "personal-training-select-trainer"
    );
    const selectPool = document.getElementById("personal-training-select-pool");
    if (form) {
        form.addEventListener("submit", function (event) {
            event.preventDefault();
            clearInputErrorStyle(form);

            let formData = new FormData(form);
            if (ageGroup.dataset.id !== "any") {
                formData.append('age_group', ageGroup.dataset.id)
            }
            if (selectTrainer.dataset.id && selectPool.dataset.id) {
                if (selectTrainer.dataset.id !== "any") {
                    formData.append("trainer_id", selectTrainer.dataset.id);
                }

                if (selectPool.dataset.id !== "any") {
                    formData.append("pool_id", selectPool.dataset.id);
                }
            }

            axios
                .post("personal-trainings/application", formData)
                .then((response) => {
                    if (response.data.success) {
                        formContainer.style.display = "none";
                        successMessage.style.display = "block";

                        try {
                            gtag('event', 'application_applied');
                            gtag('event', 'personal_training_registration');
                        } catch (e) {}
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.data) {
                        const errors = error.response.data.errors;

                        for (const field in errors) {
                            const errorMessage = errors[field][0];
                            displayError(field, errorMessage, form);
                            setInputErrorStyle(field, form);
                        }
                    }
                });
        });
    }
}

function displayError(field, message, form) {
    const errorSpan = form.querySelector(`#${field}_error`);

    errorSpan.textContent = message;
    errorSpan.style.display = "block";
}

function setInputErrorStyle(field, form) {
    const input = form.querySelector(`[data-error="${field}"]`);
    input.classList.add("border-red-500");
    input.classList.add("focus:border-red-500");
    input.classList.add("focus:ring-red-500");
    input.classList.add("bg-red-50");
}

function clearInputErrorStyle(form) {
    const inputElements = form.querySelectorAll("input");
    const textareaElements = form.querySelectorAll("textarea");
    const errorMessages = form.querySelectorAll(".input-error-message");

    inputElements.forEach((input) => {
        input.classList.remove("border-red-500");
        input.classList.remove("focus:border-red-500");
        input.classList.remove("focus:ring-red-500");
        input.classList.remove("bg-red-50");
    });

    textareaElements.forEach((textarea) => {
        textarea.classList.remove("border-red-500");
        textarea.classList.remove("focus:border-red-500");
        textarea.classList.remove("focus:ring-red-500");
        textarea.classList.remove("bg-red-50");
    });

    errorMessages.forEach((errorSpan) => {
        errorSpan.textContent = "";
        errorSpan.style.display = "none";
    });
}
